export const InitialValues = {
  'id': '',
  'organization_name_1': '',
  'organization_name_2': '',
  'organization_name_3': '',
  'program_name': [''],
  'address_country': 'US',
  'address_street1': '',
  'address_street2': '',
  'address_city': '',
  'address_county': '',
  'address_state': '',
  'address_zip': '',
  'phones': [
    {
      number: '',
      ext: '',
      type: 'Main',
      note: '',
    }
  ],
  'website_primary': '',
  'email': '',
  'website_facebook': '',
  'website_twitter': '',
  'website_linkedin': '',
  'website_instagram': '',
  'service_level': '',
  'primary_org_type': '',
  'legal_status': '',
  'status_501c3': '',
  'contact_pri_first_name': '',
  'contact_pri_last_name': '',
  'contact_pri_job_title': '',
  'contact_pri_email': '',
  'contact_pri_phone_number': '',
  'contact_pri_phone_ext': '',
  'contact_pri_phone_note': '',
  'contact_sec_first_name': '',
  'contact_sec_last_name': '',
  'contact_sec_job_title': '',
  'contact_sec_email': '',
  'contact_sec_phone_number': '',
  'contact_sec_phone_ext': '',
  'contact_sec_phone_note': '',
  'support_services': [],
  'prevention_services': [],
  'testing_services': [],
  'offer_self_testing': '_none',
  'care_and_treatment_services': [],
  'audiences': [],
  'languages': ['13974'],
  'appointment_required': '',
  'eligibility': '',
  'contact_hours': '0',
  'hours_sunday_from': '',
  'hours_sunday_to': '',
  'hours_monday_from': '',
  'hours_monday_to': '',
  'hours_tuesday_from': '',
  'hours_tuesday_to': '',
  'hours_wednesday_from': '',
  'hours_wednesday_to': '',
  'hours_thursday_from': '',
  'hours_thursday_to': '',
  'hours_friday_from': '',
  'hours_friday_to': '',
  'hours_saturday_from': '',
  'hours_saturday_to': '',
  'hours_comment': '',
  'fees': [],
  'token': '',

  'info_status': '',
  'info_first_name': '',
  'info_last_name': '',
  'info_initial': '',
  'info_job_title': '',
  'info_phone_area': '',
  'info_phone_number': '',
  'info_phone_ext': '',
  'info_email': '',
  'info_email_check': '',
}
